module.exports = __webpack_public_path__ + "static/media/app12.9915b283.png";